import { CareAllowancePlacementReleaseHoldPopupQuestion } from "../interfaces/care-allowance-placement-release-hold-popup-question.interface";

export class CareAllowancePlacementReleaseHoldRequest implements CareAllowancePlacementReleaseHoldPopupQuestion {
  constructor(
    public placementId: string,
    public placementReleaseHoldReasonTypeId: string,
    public placementReleaseHoldComments: string
  ) { }
}
